import { useMemo } from 'react'

export function useIsIframe() {
  const isIframe = useMemo(() => {
    try {
      return window.self !== window.top
    } catch (e) {
      return true
    }
  }, [window])

  return isIframe
}
